import "./index.css";
import { useRef, useState } from "react";
import { Range as RangeProps } from "./index.types";
import { usePositions, useThumb, useTimer } from "./hooks";
import { RangeThumb } from "./range-thumb";
import { RangeContent } from "./range-content";
import { RangeControls } from "./range-controls";

export function Range({ initial = 0, period, values, handleSelected }: RangeProps) {
  const panelRef = useRef(null);
  const [indexPosition, setIndexPosition] = useState<number>(initial);
  const [over, setOver] = useState<string | number | undefined>(undefined);

  const {
    allPositions,
    pixelPosition,
    setPixelPosition,
    thumbPosition,
    setThumbPosition,
  } = usePositions(panelRef, initial);

  const handlePosition = (
    pixelPosition: number,
    thumbPosition: number,
    index: number,
    isHandleSelected: boolean = false
  ) => {
    setPixelPosition(`${pixelPosition}px`);
    setThumbPosition(`${thumbPosition}px`);
    setIndexPosition(index);

    if (isHandleSelected && handleSelected) {
      handleSelected({
        value: values[index],
        index,
        position: pixelPosition,
      });
    }
  };

  const handleOverContent = (value: string | number | undefined) => {
    setOver(value);
  };

  const handleOutContent = () => {
    setOver(undefined);
  };

  const { isPlay, handlePlay, handleStop } = useTimer({
    allPositions,
    indexPosition,
    handlePosition,
    handleOverContent,
    values,
  });

  const { handleDownThumb } = useThumb({
    allPositions,
    panelRef,
    handlePosition,
    handleOverContent,
    values,
  });

  return (
    <div className="range">
      <div ref={panelRef} className="range__panel">
        <RangeContent
          period={period}
          values={values}
          allPositions={allPositions}
          handlePosition={handlePosition}
          handleOverContent={handleOverContent}
          handleOutContent={handleOutContent}
          over={over}
        />

        <div
          className="range__track"
          style={{
            width: `${pixelPosition}`,
          }}
        ></div>
        <RangeThumb
          thumbPosition={thumbPosition}
          handleOverContent={handleOverContent}
          handleDownThumb={handleDownThumb}
        />
      </div>
      <RangeControls
        indexPosition={indexPosition}
        isPlay={isPlay}
        handlePlay={handlePlay}
        handleStop={handleStop}
      />
    </div>
  );
}

export default Range;
